export default __webpack_public_path__ + "static/media/Landing.ee921192.jpg";